import {Quill} from 'react-quill';

const Parchment = Quill.import('parchment');

class CustomAlignAttributor extends Parchment.Attributor.Class {
	constructor(attrName: string, keyName: string, whitelist: string[] = []) {
		super(attrName, keyName, { whitelist });
	}

	add(node: HTMLElement, value: string): boolean {
		if (!(node instanceof HTMLElement)) {
			return false;
		}

		switch (value) {
			case 'center':
			case 'right':
			case 'justify':
				node.style.textAlign = value
				break;
			default:
				this.remove(node);
				break;
		}

		return true;
	}

	remove(node: HTMLElement): void {
		if (!(node instanceof HTMLElement)) {
			return;
		}

		node.style.textAlign = '';
	}

	value(node: HTMLElement): string | boolean {
		if (!(node instanceof HTMLElement)) {
			return false;
		}

		if (node.style.textAlign) return node.style.textAlign;
		
		if (node.classList.contains('ql-align-justify')) {
			return 'justify';
		}
		
		if (node.classList.contains('ql-align-center')) {
			return 'center';
		}
		
		if (node.classList.contains('ql-align-right')) {
			return 'right';
		}

        return false;
	}
}

Quill.register(
	'formats/align',
	new CustomAlignAttributor('align', 'ql-align', ['center', 'right', 'justify']),
	true
);
